(function () {
  const desktopBreakpoint = 990;
  const activationDistance = 35;
  const horizontalTolerance = 12;
  const closeDelay = 200;

  let accordionId = 0;
  let refreshQueued = false;
  let closeTimer = null;

  function getTopLevelItems() {
    return Array.from(
      document.querySelectorAll(
        '.header-menu .menu-list__list-item:not([slot="overflow"])'
      )
    );
  }

  function getTopLevelLink(menuItem) {
    if (!menuItem) return null;

    return menuItem.querySelector(
      ':scope > .menu-list__link'
    );
  }

  function getTopLevelSubmenu(menuItem) {
    if (!menuItem) return null;

    return menuItem.querySelector(
      ':scope > .menu-list__submenu'
    );
  }

  function closeColumn(column) {
    if (!column) return;

    column.classList.remove('is-open');

    const link = column.querySelector(
      ':scope > div > .mega-menu__link--parent'
    );

    if (link) {
      link.setAttribute(
        'aria-expanded',
        'false'
      );
    }
  }

  function closeTopLevelItem(menuItem) {
    if (!menuItem) return;

    const link = getTopLevelLink(menuItem);
const submenu = getTopLevelSubmenu(menuItem);

/*
 * Use Horizon's native deactivation routine so
 * its internal active-item state remains synchronized.
 */
const horizonHeaderMenu =
  menuItem.closest('header-menu');

if (
  horizonHeaderMenu &&
  typeof horizonHeaderMenu.deactivate === 'function' &&
  link &&
  link.getAttribute('aria-expanded') === 'true'
) {
  horizonHeaderMenu.deactivate({
    target: menuItem,
    relatedTarget: null,
    type: 'pointerleave'
  });
}

if (link && submenu) {
      link.setAttribute(
        'aria-expanded',
        'false'
      );
    }

    menuItem
      .querySelectorAll(
        '.mega-menu__column.is-open'
      )
      .forEach(function (column) {
        closeColumn(column);
      });
  }

  function openTopLevelItem(activeItem) {
    if (
      !activeItem ||
      window.innerWidth < desktopBreakpoint
    ) {
      return;
    }

    const activeLink =
      getTopLevelLink(activeItem);

    const activeSubmenu =
      getTopLevelSubmenu(activeItem);

    if (!activeLink || !activeSubmenu) {
  return;
}

/*
 * Run Horizon's native activation routine.
 * This calculates the submenu height and clip-path,
 * which aria-expanded alone does not do.
 */
const horizonHeaderMenu =
  activeItem.closest('header-menu');

if (
  horizonHeaderMenu &&
  typeof horizonHeaderMenu.activate === 'function'
) {
  horizonHeaderMenu.activate({
    target: activeItem,
    type: 'pointerenter'
  });
}

window.clearTimeout(closeTimer);

    getTopLevelItems().forEach(
      function (menuItem) {
        if (menuItem !== activeItem) {
          closeTopLevelItem(menuItem);
        }
      }
    );

    activeLink.setAttribute(
      'aria-expanded',
      'true'
    );
  }

  function scheduleCloseTopLevelMenus() {
    window.clearTimeout(closeTimer);

    closeTimer = window.setTimeout(
      function () {
        getTopLevelItems().forEach(
          function (menuItem) {
            closeTopLevelItem(menuItem);
          }
        );
      },
      closeDelay
    );
  }

  /*
   * Build independent left and right columns.
   */
  function buildIndependentColumns(root = document) {
    root
      .querySelectorAll('.mega-menu__list')
      .forEach(function (menuList) {
        const wrappers =
          menuList.querySelectorAll(
            ':scope > .mega-menu__accordion-column-wrapper'
          );

        if (wrappers.length === 2) {
          return;
        }

        const parentMenuItem =
          menuList.closest(
            '.menu-list__list-item'
          );

        const parentTrigger =
          getTopLevelLink(parentMenuItem);

        const wasOpen =
          parentTrigger &&
          parentTrigger.getAttribute(
            'aria-expanded'
          ) === 'true';

        delete menuList.dataset.independentColumns;

        const categories = Array.from(
          menuList.children
        ).filter(function (item) {
          return item.classList.contains(
            'mega-menu__column'
          );
        });

        if (!categories.length) {
          return;
        }

        menuList.dataset.independentColumns =
          'true';

        menuList.classList.add(
          'mega-menu__list--accordion'
        );

        const leftWrapper =
          document.createElement('li');

        const rightWrapper =
          document.createElement('li');

        leftWrapper.className =
          'mega-menu__accordion-column-wrapper';

        rightWrapper.className =
          'mega-menu__accordion-column-wrapper';

        const leftStack =
          document.createElement('ul');

        const rightStack =
          document.createElement('ul');

        leftStack.className =
          'mega-menu__accordion-stack list-unstyled';

        rightStack.className =
          'mega-menu__accordion-stack list-unstyled';

        categories.forEach(
          function (category, index) {
            if (index % 2 === 0) {
              leftStack.appendChild(category);
            } else {
              rightStack.appendChild(category);
            }
          }
        );

        leftWrapper.appendChild(leftStack);
        rightWrapper.appendChild(rightStack);

        menuList.appendChild(leftWrapper);
        menuList.appendChild(rightWrapper);

        if (wasOpen && parentTrigger) {
          parentTrigger.setAttribute(
            'aria-expanded',
            'true'
          );
        }
      });
  }

  /*
   * Prepare category links as accordion controls.
   */
  function prepareAccordions(root = document) {
    buildIndependentColumns(root);

    root
      .querySelectorAll('.mega-menu__column')
      .forEach(function (column) {
        const container = column.querySelector(
          ':scope > div'
        );

        if (!container) return;

        const parentLink =
          container.querySelector(
            ':scope > .mega-menu__link--parent'
          );

        const submenu =
          container.querySelector(
            ':scope > ul'
          );

        if (!parentLink || !submenu) {
          return;
        }

        if (!submenu.id) {
          accordionId += 1;

          submenu.id =
            'mega-menu-accordion-' +
            accordionId;
        }

        parentLink.setAttribute(
          'role',
          'button'
        );

        parentLink.setAttribute(
          'aria-controls',
          submenu.id
        );

        if (
          !parentLink.hasAttribute(
            'aria-expanded'
          )
        ) {
          parentLink.setAttribute(
            'aria-expanded',
            'false'
          );
        }

        /*
         * Add Shop All only if one does not exist.
         */
        if (
          !submenu.querySelector(
            '.mega-menu__shop-all'
          )
        ) {
          const item =
            document.createElement('li');

          const link =
            document.createElement('a');

          item.className =
            'mega-menu__shop-all-item';

          link.href = parentLink.href;

          link.className =
            'mega-menu__link mega-menu__shop-all';

          link.textContent =
            'Shop All ' +
            parentLink.textContent.trim();

          item.appendChild(link);

          submenu.insertBefore(
            item,
            submenu.firstChild
          );
        }
      });
  }

  /*
   * Accordion category click handling.
   */
  document.addEventListener(
    'click',
    function (event) {
      if (
        window.innerWidth < desktopBreakpoint
      ) {
        return;
      }

      const parentLink =
        event.target.closest(
          '.mega-menu__link--parent'
        );

      if (!parentLink) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      buildIndependentColumns(document);

      const column =
        parentLink.closest(
          '.mega-menu__column'
        );

      if (!column) return;

      const submenu = column.querySelector(
        ':scope > div > ul'
      );

      if (!submenu) return;

      /*
       * Collapse an already-open category.
       */
      if (
        column.classList.contains('is-open')
      ) {
        closeColumn(column);
        return;
      }

      const stack = column.closest(
        '.mega-menu__accordion-stack'
      );

      /*
       * Close another category only within
       * the same left or right column.
       */
      if (stack) {
        stack
          .querySelectorAll(
            '.mega-menu__column.is-open'
          )
          .forEach(function (openColumn) {
            closeColumn(openColumn);
          });
      }

      column.classList.add('is-open');

      parentLink.setAttribute(
        'aria-expanded',
        'true'
      );

      submenu.scrollTop = 0;
    },
    true
  );

  /*
   * Open top-level dropdowns from direct hover.
   */
  document.addEventListener(
    'pointerover',
    function (event) {
      if (
        window.innerWidth < desktopBreakpoint
      ) {
        return;
      }

      const menuItem =
        event.target.closest(
          '.header-menu .menu-list__list-item:not([slot="overflow"])'
        );

      if (menuItem) {
        openTopLevelItem(menuItem);
        return;
      }

      if (
        event.target.closest(
          '.menu-list__submenu'
        )
      ) {
        window.clearTimeout(closeTimer);
        return;
      }

      scheduleCloseTopLevelMenus();
    },
    true
  );

  /*
   * Create a real activation zone beneath the
   * navigation for upward cursor movement.
   */
  document.addEventListener(
    'pointermove',
    function (event) {
      if (
        window.innerWidth < desktopBreakpoint
      ) {
        return;
      }

      const menuList =
        document.querySelector(
          '.header-menu .menu-list'
        );

      if (!menuList) return;

      const menuRect =
        menuList.getBoundingClientRect();

      const insideActivationBand =
        event.clientY >= menuRect.top &&
        event.clientY <=
          menuRect.bottom +
            activationDistance;

      if (!insideActivationBand) return;

      const matchingItem =
        getTopLevelItems().find(
          function (menuItem) {
            const link =
              getTopLevelLink(menuItem);

            if (!link) return false;

            const linkRect =
              link.getBoundingClientRect();

            return (
              event.clientX >=
                linkRect.left -
                  horizontalTolerance &&
              event.clientX <=
                linkRect.right +
                  horizontalTolerance
            );
          }
        );

      if (matchingItem) {
        openTopLevelItem(matchingItem);
      }
    },
    { passive: true }
  );

  /*
   * Close after leaving the header and submenu.
   */
  document.addEventListener(
    'pointerout',
    function (event) {
      if (
        window.innerWidth < desktopBreakpoint
      ) {
        return;
      }

      const leavingMenu =
        event.target.closest(
          '.header-menu, .menu-list__submenu'
        );

      if (!leavingMenu) return;

      const nextTarget =
        event.relatedTarget;

      if (
        nextTarget &&
        nextTarget.closest &&
        nextTarget.closest(
          '.header-menu, .menu-list__submenu'
        )
      ) {
        return;
      }

      scheduleCloseTopLevelMenus();
    },
    true
  );

  /*
   * Escape closes categories and top-level menus.
   */
  document.addEventListener(
    'keydown',
    function (event) {
      if (event.key !== 'Escape') return;

      document
        .querySelectorAll(
          '.mega-menu__column.is-open'
        )
        .forEach(function (column) {
          closeColumn(column);
        });

      getTopLevelItems().forEach(
        function (menuItem) {
          closeTopLevelItem(menuItem);
        }
      );
    }
  );
/*
 * Ensure top-level dropdowns activate when the
 * navigation is approached from any direction.
 *
 * Direct pointerenter listeners are more reliable
 * than delegated pointerover events in Horizon's
 * overflow-list component.
 */
function bindTopLevelHoverListeners() {
  getTopLevelItems().forEach(
    function (menuItem) {
      if (
        menuItem.dataset.directHoverBound ===
        'true'
      ) {
        return;
      }

      const link =
        getTopLevelLink(menuItem);

      const submenu =
        getTopLevelSubmenu(menuItem);

      if (!link || !submenu) return;

      menuItem.dataset.directHoverBound =
        'true';

      function activateMenu() {
        if (
          window.innerWidth <
          desktopBreakpoint
        ) {
          return;
        }

        window.clearTimeout(closeTimer);

        /*
         * Run after Horizon's own pointer handler
         * so our open state is applied last.
         */
        window.requestAnimationFrame(
          function () {
            openTopLevelItem(menuItem);
          }
        );
      }

      /*
       * Listen on both the full menu item and
       * the visible navigation link.
       */
      menuItem.addEventListener(
        'pointerenter',
        activateMenu
      );

      link.addEventListener(
        'pointerenter',
        activateMenu
      );

      /*
       * Mouseenter provides an additional fallback
       * for desktop browsers and theme previews.
       */
      link.addEventListener(
        'mouseenter',
        activateMenu
      );
    }
  );
}
  function initialize(root = document) {
  prepareAccordions(root);
  bindTopLevelHoverListeners();
}

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        initialize(document);
      }
    );
  } else {
    initialize(document);
  }

  /*
   * Reinitialize inside Shopify's theme editor.
   */
  document.addEventListener(
    'shopify:section:load',
    function (event) {
      initialize(event.target);
    }
  );

  /*
   * Rebuild when Horizon replaces menu markup.
   */
  const observer = new MutationObserver(
    function (mutations) {
      const menuChanged = mutations.some(
        function (mutation) {
          return Array.from(
            mutation.addedNodes
          ).some(function (node) {
            if (node.nodeType !== 1) {
              return false;
            }

            return (
              node.matches?.(
                '.mega-menu__list, .mega-menu__column'
              ) ||
              node.querySelector?.(
                '.mega-menu__list, .mega-menu__column'
              )
            );
          });
        }
      );

      if (!menuChanged || refreshQueued) {
        return;
      }

      refreshQueued = true;

      window.requestAnimationFrame(
        function () {
          initialize(document);
          refreshQueued = false;
        }
      );
    }
  );

  function beginObserver() {
    if (!document.body) return;

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.body) {
    beginObserver();
  } else {
    document.addEventListener(
      'DOMContentLoaded',
      beginObserver
    );
  }
})();